import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setClient } from "../../store/slices/clientsSlice";
import ClientModal from "../../modals/ClientModal";

export default function RecallToDoItem({ client }) {
  const dispatch = useDispatch();
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);

  const handleActionClick = () => {
    dispatch(setClient(client));
    setIsClientModalOpen(true);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
    };
    return date.toLocaleDateString("en-US", options);
  };

  const getRecallDate = () => {
    const latestRecallStatus = client.statusHistory
      ?.filter((status) => status.status === "recall")
      .sort((a, b) => b.changedAt - a.changedAt)[0];
    return latestRecallStatus?.recallDate;
  };

  const handleCloseModal = () => {
    setIsClientModalOpen(false);
  };

  const recallDate = getRecallDate();

  return (
    <>
      <li className="relative flex items-center space-x-4 py-4">
        <div className="flex-auto min-w-0">
          <div className="flex items-center gap-x-1.5">
            <h2 className="flex-1 min-w-0 text-sm font-semibold leading-6 text-gray-900">
              <div className="flex">
                <span className="truncate">Recall Client</span>
              </div>
            </h2>
          </div>
          <div className="flex justify-between">
            <div className="mt-3 text-xs leading-5 text-gray-500">
              <p>
                {client.firstName} {client.lastName}
                {client.preferredName && ` (${client.preferredName})`}
              </p>
              {recallDate && <p>{formatDate(recallDate)}</p>}
            </div>
            <div className="flex-shrink-0 flex items-end space-x-2 mt-3">
              <button
                onClick={handleActionClick}
                className="rounded-full px-2 py-1 text-xs font-medium bg-gray-100 hover:bg-gray-200">
                View
              </button>
            </div>
          </div>
        </div>
      </li>
      {isClientModalOpen && (
        <ClientModal
          isOpen={isClientModalOpen}
          onClose={handleCloseModal}
        />
      )}
    </>
  );
}
